/**************************************************************************************************/
/*   File: /src/app/stores/states/root/state.ts                                                   */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromRouter from '@ngrx/router-store/src/router_store_module';

import * as fromAuthorization from '../authorization/state';
import * as fromDossiers from '../dossiers/state';
import * as fromDownload from '../download/state';
import * as fromCreation from '../creation/state';
import * as fromDetails from '../details/state';
import * as fromEditing from '../editing/state';
import * as fromUi from '../ui/state';

/**
 * The newplan frontend state
 */
export interface RootState {
  /**
   * The ui state
   */
  ui: fromUi.State;
  /**
   * The authorization state
   */
  authorization: fromAuthorization.AuthorizationState;
  /**
   * The router state
   */
  router?: fromRouter.RouterReducerState;
  /**
   * The download state
   */
  download: fromDownload.DownloadState;
  /**
   * The dossier creation state
   */
  creation: fromCreation.CreationState;
  /**
   * The dossier details state
   */
  details: fromDetails.DetailsState;
  /**
   * The dossier editing state
   */
  editing: fromEditing.EditingState;
  /**
   * The dossiers state
   */
  dossiers: fromDossiers.DossiersState;  
}

/**
 * The state name
 */
export const STATE_NAME = 'root';